<mat-drawer-container
    [hasBackdrop]="true"
    [style.background-color]="'var(--background-color-primary)'"
>
    <mat-drawer
        [opened]="drawerOpen"
        position="end"
        #drawer
        (closed)="onDrawerClosed()"
    >
        @defer (when !loading) {
            <app-report-adjustments-sidenav
                [report]="report"
                [company]="company"
                [scenarios]="report.scenarios"
                [currentPage]="initialPageSidenav"
                [dropdownConfigs]="{
                    period: {
                        equalYear: true
                    },
                    comparation: {
                        equalYear: true
                    }
                }"
                [optionsNavigation]="{
                    period: true,
                    comparation: true,
                    analysisplus: false
                }"
                style="height: 100%"
                (handleChangePeriod)="onChangePeriod($event)"
                (handleChangeComparation)="onChangeComparation($event)"
                (handleResetPeriod)="onResetPeriod()"
                (onOptionSelected)="onOptionSelected($event)"
                (onClose)="onDrawerClosed()"
            ></app-report-adjustments-sidenav>
        }
    </mat-drawer>
    <mat-drawer-content id="ReportContentMobileScroll">
        <div id="ReportBudgetMobile" fxLayout="column">
            <app-report-header
                [options]="report?.options"
                [company]="company"
                [reportName]="report?.props?.name"
            ></app-report-header>
            <div
                style="position: sticky; top: 0; z-index: 1000"
                [style.background-color]="'var(--background-color-primary)'"
            >
                <app-report-toolbar
                    [options]="report?.options"
                    [company]="company"
                    [loading]="loading"
                    [dropdowns]="{
                        period: true,
                        comparation: true
                    }"
                    [dropdownConfigs]="{
                        period: {
                            equalYear: true
                        },
                        comparation: {
                            equalYear: true
                        }
                    }"
                    (handleResetPeriod)="onResetPeriod()"
                ></app-report-toolbar>
            </div>
            <div
                fxLayout="column"
                style="padding: var(--spacing-12); gap: var(--spacing-16)"
                [style.marginBottom]="'84px'"
            >
                <dsn-expand-collapse
                    id="SectionBenchmarking"
                    [isExpanded]="sectionStates['SectionBenchmarking']"
                    [customIcon]="'images/icons/benchmarking-icon.svg'"
                    [label]="'Benchmarking'"
                    [type]="'default'"
                    [style.display]="hasBenchmarking ? 'block' : 'none'"
                    [fontSize]="'medium'"
                >
                    <app-report-beachmarking-section
                        [report]="report"
                        [company]="company"
                        [loading]="loading"
                        [previewMode]="previewMode"
                        (handleBenchmarkingDataLoaded)="
                            onBenchmarkingDataLoaded($event)
                        "
                    ></app-report-beachmarking-section>
                </dsn-expand-collapse>

                <dsn-expand-collapse
                    id="SectionPerformance"
                    [isExpanded]="sectionStates['SectionPerformance']"
                    [customIcon]="'images/icons/performance-icon.svg'"
                    [label]="'Performance'"
                    [type]="'default'"
                    [fontSize]="'medium'"
                >
                    @if (!loading) {
                        <app-report-performance
                            [visualizations]="report.visualizations"
                            [options]="report.options"
                            [report]="report"
                            [company]="company"
                            [previewMode]="previewMode"
                        ></app-report-performance>
                    } @else {
                        <div fxLayout="column" class="padding-12 gap-12">
                            <div
                                fxLayout="row"
                                fxLayoutAlign="center center"
                                class="gap-12"
                            >
                                <dsn-skeleton-loader
                                    [type]="'circle'"
                                    [width]="'80px'"
                                    [height]="'80px'"
                                ></dsn-skeleton-loader>
                                <div fxLayout="column" class="gap-4">
                                    @for (item of [1, 2, 3, 4]; track item) {
                                        <dsn-skeleton-loader
                                            [type]="'rectangle'"
                                            [width]="'100px'"
                                            [height]="'14px'"
                                        ></dsn-skeleton-loader>
                                    }
                                </div>
                            </div>
                            <dsn-skeleton-loader
                                [type]="'rectangle'"
                                [width]="'200px'"
                                [height]="'20px'"
                            ></dsn-skeleton-loader>
                            <div fxLayout="row" class="gap-12">
                                <dsn-skeleton-loader
                                    [type]="'rectangle'"
                                    [width]="'100px'"
                                    [height]="'34px'"
                                ></dsn-skeleton-loader>
                                <dsn-skeleton-loader
                                    [type]="'rectangle'"
                                    [width]="'100px'"
                                    [height]="'34px'"
                                ></dsn-skeleton-loader>
                            </div>
                            <dsn-skeleton-loader
                                [type]="'rectangle'"
                                [width]="'100%'"
                                [height]="'38px'"
                            ></dsn-skeleton-loader>
                            <dsn-skeleton-loader
                                [type]="'rectangle'"
                                [width]="'100%'"
                                [height]="'38px'"
                            ></dsn-skeleton-loader>
                        </div>
                    }
                </dsn-expand-collapse>

                <dsn-expand-collapse
                    id="SectionIndicators"
                    [isExpanded]="sectionStates['SectionIndicators']"
                    [customIcon]="'images/icons/indicators-icon.svg'"
                    label="Indicadores"
                    type="transparent"
                    [fontSize]="'medium'"
                >
                    <div fxLayout="column" class="gap-16">
                        <div fxLayout="column" class="budget-table-wrapper">
                            <span class="text-14-semi-bold color-text-primary"
                                >Orçamento</span
                            >
                            @defer (when !loading) {
                                <app-table-budget
                                    [options]="report?.options"
                                    [loading]="loading"
                                    [company]="company"
                                ></app-table-budget>
                            } @placeholder {
                                <dsn-skeleton-loader
                                    [type]="'rectangle'"
                                    [width]="'100%'"
                                    [height]="'34px'"
                                ></dsn-skeleton-loader>
                            }
                        </div>
                    </div>
                </dsn-expand-collapse>
                @if (!previewMode && contact?.props?._id !== "convidadoId") {
                    <dsn-expand-collapse
                        id="SectionFeedback"
                        [isExpanded]="sectionStates['SectionFeedback']"
                        [icon]="'fa-regular fa-message'"
                        [label]="'Feedback'"
                        [type]="'default'"
                    >
                        <app-report-feedback-form
                            [report]="report"
                        ></app-report-feedback-form>
                    </dsn-expand-collapse>
                }
            </div>
        </div>
        @defer (when !loading) {
            @if (!previewMode) {
                <div
                    fxLayout="column"
                    fxLayoutAlign="center center"
                    style="
                        width: 100%;
                        position: fixed;
                        bottom: 16px;
                        padding: 0px 24px;
                        z-index: 1000;
                    "
                >
                    <app-menu-bottom-mobile
                        [isShowNanda]="
                            contact?.props?._id !== 'convidadoId' &&
                            contact?.props?._id !== undefined &&
                            contact?.props?._id !== null
                        "
                        [style]="
                            contact?.props?._id !== 'convidadoId'
                                ? 'width: 100%'
                                : ''
                        "
                        [report]="report"
                        [company]="company"
                        (onOptionSelected)="onOptionSelected($event)"
                    ></app-menu-bottom-mobile>
                </div>
            }
        } @placeholder {}
    </mat-drawer-content>
</mat-drawer-container>
